import React, { ReactNode } from "react";

export interface SquareProps {
  w?: number;
  h?: number;
  children: ReactNode;
}

const Ratio = ({ w = 1, h = 1, children }: SquareProps) => {
  return (
    <div
      className="relative w-full"
      style={{
        paddingTop: (h / w) * 100 + "%",
      }}
    >
      <div className="absolute top-0 left-0 w-full h-full">{children}</div>
    </div>
  );
};

export default Ratio;
